import {
  average_overall,
  average_by_area,
  average_by_cluster,
  active_by_area,
  active_by_cluster,
  active_overall,
  expired_overall,
  expired_by_area,
  expired_by_cluster,
  expired_by_branch,
  active_by_branch,
  average_by_branch,
} from "../../services/reports/sales_service";

import { actionTypes } from "../action_types";

const createSalesAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    let processedPayload = [];
    let promises = [];

    if (Array.isArray(data.dates)) {
      data.dates.forEach((item) =>
        promises.push(fetchFunction({ ...data, ...item }))
      );
    } else {
      promises.push(fetchFunction(data));
    }

    return Promise.all(promises).then((resp) => {
      processedPayload = resp.map((element) => element.data);
      if (resp.every((response) => response.problem === null)) {
        dispatch({
          type: actionType,
          payload: processedPayload,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetOverallAverage = createSalesAction(
  average_overall,
  actionTypes.REPORTS_SALES_GET_OVERALL_AVERAGE
);

export const GetAverageByCluster = createSalesAction(
  average_by_cluster,
  actionTypes.REPORTS_SALES_GET_CLUSTER_AVERAGE
);

export const GetAverageByArea = createSalesAction(
  average_by_area,
  actionTypes.REPORTS_SALES_GET_AREA_AVERAGE
);

export const GetAverageByBranch = createSalesAction(
  average_by_branch,
  actionTypes.REPORTS_SALES_GET_BRANCH_AVERAGE
);

export const GetOverallActive = createSalesAction(
  active_overall,
  actionTypes.REPORTS_SALES_GET_OVERALL_ACTIVE
);

export const GetActiveByCluster = createSalesAction(
  active_by_cluster,
  actionTypes.REPORTS_SALES_GET_CLUSTER_ACTIVE
);

export const GetActiveByArea = createSalesAction(
  active_by_area,
  actionTypes.REPORTS_SALES_GET_AREA_ACTIVE
);

export const GetActiveByBranch = createSalesAction(
  active_by_branch,
  actionTypes.REPORTS_SALES_GET_BRANCH_ACTIVE
);

export const GetOverallExpired = createSalesAction(
  expired_overall,
  actionTypes.REPORTS_SALES_GET_OVERALL_EXPIRED
);

export const GetExpiredByCluster = createSalesAction(
  expired_by_cluster,
  actionTypes.REPORTS_SALES_GET_CLUSTER_EXPIRED
);

export const GetExpiredByArea = createSalesAction(
  expired_by_area,
  actionTypes.REPORTS_SALES_GET_AREA_EXPIRED
);

export const GetExpiredByBranch = createSalesAction(
  expired_by_branch,
  actionTypes.REPORTS_SALES_GET_BRANCH_EXPIRED
);
